// group-trust-browser.js
// Browser-only wrapper: IndexedDB persistence for GroupTrustStore. Same
// pattern as group-trust.js (Node's filesystem wrapper) — the actual
// trust/authentication logic (the security-critical part) lives in
// group-trust-core.js and is never duplicated between the two platforms.
// See group-trust-core.js's own comment for why that matters.

import { GroupTrustStore as CoreGroupTrustStore } from '../group-trust-core.js'
import { IndexedDbStorage } from './storage-browser.js'

export class GroupTrustStore extends CoreGroupTrustStore {
  /** No path argument, unlike the Node version — fixed IndexedDB key, one trust store per browser origin. */
  constructor () {
    super(new IndexedDbStorage('group-trust'))
  }
}
